import { UserWorkoutSession } from 'fitbeat.gym-core';
import { createBookingServiceClient } from './apiClientFactory';

export const getOpenInviteLink =async (workoutSession: UserWorkoutSession) => {
  const bookingServiceClient = createBookingServiceClient();
  const openInviteLink = workoutSession.openInviteLink ||
    await bookingServiceClient.getOpenInviteLinkForWorkout(workoutSession.uniqueReference)
      .then((response) => response.link);
  return openInviteLink;
}
